import script from "./CompanyCardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyCardHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyCardHeader.vue?vue&type=style&index=0&id=3890381b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3890381b"]])

export default __exports__